import axios from "axios";

export const readComp = async (thisCompany) => {
    
        try{
            return axios.get(`${process.env.REACT_APP_BACKEND_URL}/CompanyProfile?thisCompany=${thisCompany}`,{
            })
        } catch(error){
            throw new Error(error);
        }
   

}